<template>
  <main class="wrapper-content w-100">
    <div class="h-100" v-if="!isLoading">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="mb-4">Bandeja de Entrada</h2>
        <b-button variant="primary" v-b-tooltip.hover.left title="Actualizar" @click="getMyInbox">
          <i class="load-icon mdi mdi-autorenew" :class="{'rotate': loadingInbox}"></i>
        </b-button>
      </div>
      <LmSvgIcon
        v-if="!inboxWidgets.length"
        style="height: calc(100% - 35px - 1.5rem); padding-bottom: calc((35px + 1.5rem) * 2);"
        wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
        width="18em"
        icon="LmInboxIcon"
        text="Tu Bandeja de Entradas aparecerá aquí"
      />
      <b-row v-if="inboxWidgets.length">
        <LmWidget
          v-for="(widget, index) of inboxWidgets"
          :singleMode="isSingleMode(widget)"
          :key="index"
          :component="widget.component"
          :widget="widget"
          :customization="widget.customization"
        />
      </b-row>
    </div>
    <LmLoading v-else />
  </main>
</template>

<script>
import commonsApi from '@/api/commons'
import LmWidget from '@/components/LmWidget'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  data () {
    return {
      isLoading: false,
      widgets: [],
      inboxWidgets: [],
      loadingInbox: false
    }
  },
  components: {
    LmWidget
  },
  methods: {
    isSingleMode (event) {
      return !Array.isArray(event)
    },
    async getMyInbox () {
      try {
        this.loadingInbox = true
        this.inboxWidgets = []
        // Obtengo la bandeja de entrada
        const myInbox = await commonsApi.axiosGetWrapper('/inbox/myinbox')
        if (myInbox.data && Object.keys(myInbox.data.widgets).length) {
          this.inboxWidgets = myInbox.data.widgets
        } else {
          console.log('No hay widgets definidos para tu Bandeja de Entrada')
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingInbox = false
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      // Obtengo todos los widgets
      const widgets = await commonsApi.axiosGetWrapper('/widgets/all?view=inbox')
      this.widgets = widgets.data.map(el => {
        return {
          id: el?._id,
          component: el?.component,
          name: el?.name,
          properties: el?.properties
        }
      })
      // Obtengo la bandeja de entrada
      await this.getMyInbox()
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
.load-icon
  &:before
    font-size: 18px
@-webkit-keyframes rotate /* Safari and Chrome */
  from
    -webkit-transform: rotate(0deg)
    -o-transform: rotate(0deg)
    transform: rotate(0deg)

  to
    -webkit-transform: rotate(360deg)
    -o-transform: rotate(360deg)
    transform: rotate(360deg)

@keyframes rotate
  from
    -ms-transform: rotate(0deg)
    -moz-transform: rotate(0deg)
    -webkit-transform: rotate(0deg)
    -o-transform: rotate(0deg)
    transform: rotate(0deg)

  to
    -ms-transform: rotate(360deg)
    -moz-transform: rotate(360deg)
    -webkit-transform: rotate(360deg)
    -o-transform: rotate(360deg)
    transform: rotate(360deg)

.rotate
  &::before
    -webkit-animation: rotate 2s linear infinite
    -moz-animation: rotate 2s linear infinite
    -ms-animation: rotate 2s linear infinite
    -o-animation: rotate 2s linear infinite
    animation: rotate 2s linear infinite
</style>
